import { render, staticRenderFns } from "./SmsTemplateList.vue?vue&type=template&id=3ecc3bd2&scoped=true"
import script from "./SmsTemplateList.vue?vue&type=script&lang=ts"
export * from "./SmsTemplateList.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ecc3bd2",
  null
  
)

export default component.exports